import base from './base';
import { getAntd, getLabel } from './convert';

// export const getoDocIframeUrl = (info) =>{
//     let url = info.docUrl+"?";
//     for(const key in info.docParam){
//         url += key+"="+encodeURIComponent(info.docParam[key])+"&"
//     }
//     return url;
// }

/**
 * 节流函数，用于正文页签上方按钮的点击事件比较频繁，进行优化
 */
const throttle = (fun, wait = 2500) => {
  const { message } = getAntd();
  let pre = Date.now() - 2500;
  return (...args) => {
    const now = Date.now();
    if (now - pre >= wait) {
      fun.apply(this, args);
      pre = Date.now();
    } else {
      message.warn(getLabel('524062', '操作频繁，请稍后再试'));
    }
  };
}

export const getoDocTopButtons = (info) => {
  const { btnDisabled } = base.globalStore;
  const { Button } = getAntd();
  let btnArr = [];
  info && info.buttons && info.buttons.map(btn => {
    if (btn.isshow === true)
      btnArr.push(<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@lvg4jk@odocbtn`} type="primary" disabled={btnDisabled} onClick={throttle(() => {
        window.oDocUtil.odocBtnEvent(btn.key)
      })}>{btn.title}</Button>);
  });
  return btnArr;
}

//显示文档 、正文
/**
 * params：
 * docid: 文档id
 * requestid:请求id
 * type:0 公文，1 文档
 */
window.addDocReadTag = (docId) =>{
	//DocReadTagUtil.addDocReadTag(docId,<%=user.getUID()%>,<%=user.getLogintype()%>,"<%=request.getRemoteAddr()%>",returnTrue);
}

export const showDoc = (params) =>{
	workflow_form_doc_operation.showDoc(params);
}

//创建文档、正文
export const createDoc = (fieldMark, commonParam) =>{
	const { message } = getAntd();
	const { workflowid,f_weaver_belongto_userid,f_weaver_belongto_usertype,newdocpath,secretLevel,secLevelInfo={} } = commonParam;
	if(secLevelInfo.isOpenSec && secretLevel == ""){
		message.error(secLevelInfo.tip);
		return;
	}
	let params = {};
	params.wfid  = workflowid;
	params.f_weaver_belongto_userid = f_weaver_belongto_userid;
	params.f_weaver_belongto_usertype = f_weaver_belongto_usertype;
	params.docfileid = fieldMark.substring(5);
	params.secid = newdocpath;
	params._secretLevel = secretLevel;
	workflow_form_doc_operation.createDoc(params); 
}

if (window.location.hash && window.location.hash.indexOf("#/main/workflow/req")==0 && window.location.hash.indexOf("isOdocChangeType=1") > 0) {
  try {
    let nod = document.createElement('style');
    let str = '.wea-right-menu{display: none !important;}.wea-new-top-req-wapper{padding-top: 0;}.wea-new-top-req-wapper .wea-new-top-req{display:none;}.wf-req-form-wrapper>div{display:none;}' +
        '.wf-req-form-wrapper>div.wf-req-form{display:block;}#odocmask{position: absolute;left: 0;top: 0;width: 100%;height: 100%;z-index: 999;}}';
    nod.type = 'text/css';
    if (nod.styleSheet) { //ie下
      nod.styleSheet.cssText = str;
    } else {
      nod.innerHTML = str;
    }
    document.getElementsByTagName('head')[0].appendChild(nod);
    let i = 0;
    let timer = setInterval(() => {
      if (window.WfForm && WfForm.getGlobalStore && WfForm.getGlobalStore().JSComplete == true && window.jQuery) {
        if (jQuery("#odocmask").length <= 0 && jQuery(".wf-req-form").length > 0) {
          let height = jQuery(".wf-req-form").eq(0).height();
          jQuery(".wf-req-form").eq(0).append("<div id='odocmask' style='height:" + (height + 100) + "px'></div>")
        } else if (jQuery("#odocmask").length > 0) {
          let height = jQuery(".wf-req-form").eq(0).height();
          let marginTop = parseInt(jQuery(".wf-req-form-wrapper").eq(0).css("marginTop")) + 10;
          jQuery("#odocmask").css({height: (height + marginTop) + "px"})
        }
        i++;
        if (i == 10) {
          clearInterval(timer);
        }
      }
    }, 1000)
  } catch (e) {
    if (window.console) {
      console.log(e);
    }
  }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/otherModule.js